// Self-contained constants for the Docs / Training module.

export const DOCS_ROUTE = '/docs'
export const DOCS_PAGE_ROUTE = '/docs/:slug'

export const DOC_MEDIA_UPLOAD_PATH = '/docs/media/upload'

export const DOCS_LABELS = {
  TITLE: 'Docs & Training',
  EMPTY_TREE: 'No documentation pages yet.',
  EMPTY_PERSONAL_TREE: 'No personal documents yet.',
  EMPTY_SEARCH: 'No pages match your search.',
  EMPTY_SELECTION: 'Select a page from the sidebar to start reading.',
  SEARCH_PLACEHOLDER: 'Search pages…',
  SCOPE_ORG: 'Organization',
  SCOPE_PERSONAL: 'My Pages',
  SCOPE_PERSONAL_HINT: 'Pages here are private — visible only to you under My Pages.',
  // page visibility control (editor)
  VISIBILITY: 'Visibility',
  VISIBILITY_ORG: 'Organization',
  VISIBILITY_PRIVATE: 'Private',
  VISIBILITY_ORG_HINT: 'Visible to the whole organization once published.',
  VISIBILITY_PRIVATE_HINT: 'Private to you — appears under My Pages.',
  // home / search page
  HOME_TITLE: 'Documentation',
  HOME_SUBTITLE: 'Search the knowledge base and pick up where you left off.',
  SEARCH_BOX_PLACEHOLDER: 'Search documentation by title or content…',
  SEARCH_PROMPT: 'Start typing to search across all documentation.',
  SEARCH_NO_RESULTS: 'No documents match your search.',
  SEARCH_RESULTS_COUNT: 'result',
  RECENT_ACTIVITY: 'Recent activity',
  RECENT_EMPTY: 'No recent updates yet.',
  NEW_PAGE: 'New page',
  NEW_SUBPAGE: 'New sub-page',
  UNTITLED: 'Untitled page',
  DRAFT_BADGE: 'Draft',
  ARCHIVED_BADGE: 'Archived',
  AUTOSAVING: 'Saving…',
  SAVED: 'All changes saved',
  PUBLISH: 'Publish',
  ARCHIVE: 'Archive',
  UNARCHIVE: 'Unarchive',
  HOME_CRUMB: 'Docs',
  EDIT: 'Edit',
  DELETE: 'Delete',
  HISTORY: 'History',
  EDITOR_PLACEHOLDER: 'Start writing your documentation… use the toolbar to format text and embed images, videos and PDFs.',
}

export const DOC_MEDIA_ACCEPT = {
  image: 'image/png,image/jpeg,image/gif,image/webp,image/svg+xml',
  video: 'video/mp4,video/webm,video/quicktime',
  pdf: 'application/pdf',
}

export const DOCS_MESSAGES = {
  CREATE_SUCCESS: 'Page created',
  PUBLISH_SUCCESS: 'Page published',
  ARCHIVE_SUCCESS: 'Page archived',
  UNARCHIVE_SUCCESS: 'Page restored',
  DELETE_SUCCESS: 'Page deleted',
  VISIBILITY_SUCCESS: 'Visibility updated',
  DELETE_CONFIRM: 'Delete this page and all of its sub-pages? This cannot be undone.',
  UPLOAD_ERROR: 'Failed to upload media. Please try again.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
}

// Autosave debounce for the editor working copy (ms).
export const DOC_AUTOSAVE_DELAY = 1500
